import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const reasons = ['Standard medicine treats the physical "morsel" but ignores the emotional "shock" that created it.', 'Supplements address the nutritional gap but not the neurological "stuck" state in your nervous system.', "Positive thinking fails because it's a conscious tool trying to fix a subconscious biological program.", 'Most "healing" books are too theoretical and don\'t give you the exact "translation" for your specific pain.'];
export function WhyItDidntWork() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-navy-light py-20 px-6 md:px-12" data-id="element-158">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.8
    }} className="max-w-5xl mx-auto space-y-12" data-id="element-159">
        <h2 className="text-3xl md:text-5xl font-bold text-white text-center" data-id="element-160">
          Why What You Tried Didn't Work
        </h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-161">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: -20
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="flex gap-4 items-start bg-dark-navy p-6 rounded-lg" data-id="element-162">
              <XCircleIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-163" />
              <p className="text-stone-300 leading-relaxed" data-id="element-164">{reason}</p>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}